module.exports = __webpack_public_path__ + "img/14.acc8e88e.jpg";